import { gql } from '@apollo/client';

export default gql`
  fragment Thread on Thread {
    _id
    title
    content

    user {
      _id
      name
      email
      profilePicture
    }

    createdAt
    edited
    score
    views
    answersCount

    canUpvote
    canDownvote
    canDelete
    canEdit
    canReport
  }
`;
